import isAdmin from "./utils/isAdmin";

function IfAdmin(props) {
  const { user } = props;
  return isAdmin(user) ? props.children : <></>;
}

export default IfAdmin;
